import { currency } from '@carvana/purchase-utils';
import React from 'react';
import PropTypes from 'prop-types';
import * as sc from './term-slider-v3.styles';

const TermSliderV3 = props => {
  const {
    label,
    name,
    formatAsCurrency,
    value,
    min,
    max,
    step,
    secondaryLabel,
    id,
    onSelect
  } = props;

  const onSliderChange = e => {
    e.persist();
    const { onChange } = props;
    if (onChange) onChange(e.target.value);
  };

  return (
    <sc.Wrapper>
      <sc.Content>
        <sc.ContentLeftWrapper>
          <sc.ContentLeft>{label}</sc.ContentLeft>
          <sc.ContentLeftSecondary>
            {secondaryLabel || <br />}
          </sc.ContentLeftSecondary>
        </sc.ContentLeftWrapper>
        <sc.ContentRight data-cv-test={`selected${name}`}>
          {formatAsCurrency
            ? currency(value, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })
            : value}
        </sc.ContentRight>
      </sc.Content>

      <sc.SliderContainer>
        <sc.Slider
          type="range"
          min={min}
          max={max}
          value={value}
          step={step}
          id={name}
          name={name}
          onChange={onSliderChange}
          data-cv-test={`${name}Slider`}
          style={{
            background: `linear-gradient(#00AED9, #00AED9) 0 / calc(.5*2rem + calc((${value} - ${min})/calc(${max} - ${min}))*(100% - 2rem)) 100% no-repeat #d3d3d3`
          }}
        />
      </sc.SliderContainer>

      <sc.SliderValuesWrapper>
        <sc.SliderValues>
          {formatAsCurrency
            ? currency(min, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })
            : min}
        </sc.SliderValues>

        <sc.SliderValues>
          {formatAsCurrency
            ? currency(max, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })
            : max}
        </sc.SliderValues>
      </sc.SliderValuesWrapper>
    </sc.Wrapper>
  );
};

TermSliderV3.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  secondaryLabel: PropTypes.string,
  name: PropTypes.string.isRequired,
  formatAsCurrency: PropTypes.bool,
  value: PropTypes.number,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  id: PropTypes.string,
  onSelect: PropTypes.func
};

TermSliderV3.defaultProps = {
  formatAsCurrency: true,
  value: 0,
  min: '0',
  max: '100',
  step: 1,
  secondaryLabel: ''
};

export default TermSliderV3;
